import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage  }) => {
  const [formData, setFormData] = useState({
    port: '',
    portType: '',
    feeType: '',
    commodity: '',
    subCommodity: '',
    subSubCommodity: '',
    vessel: '',
    imoNumber: '',
    portOfRegistry: '',

    officialNumber: '',
    flag: '',
    coastal: '',
    dwt: '',
    grt: '',
    nrt: '',
    arrivalDate: '',
    commencementDate: '',
    departureDate: '',
    transhipment: '',

    lastPortCall: '',
    nextPortCall: '',
    completionDate: '',
    supportingDoc: '',
    rate: null,
    quantity: '',
    total: null,
    penaltyDays: null,
    penaltyAmount: null,
    penaltyTotal: null,

    grandTotal: null,
    tds: null,
    cgst: null,
    sgst: null,
    igst: null,
    finalAmount: null,
    paymentMode: '',
    paymentStatus: '',


  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.port === '') {
      formErrors.port = 'portId cannot be empty';
    }

    if (formData.portType === '') {
      formErrors.portType = 'portTypeId cannot be empty';
    }
    if (formData.feeType === '') {
      formErrors.feeType = 'feeTypeId cannot be empty';
    }
    if (formData.commodity === '') {
      formErrors.commodity = 'commodityId cannot be empty';
    }
    if (formData.subCommodity === '') {
      formErrors.subCommodity = 'subCommodityId cannot be empty';
    }
    if (formData.subSubCommodity === '') {
      formErrors.subSubCommodity = 'subSubCommodityId cannot be empty';
    }
    if (formData.vessel === '') {
      formErrors.vessel = 'vesselId cannot be empty';
    }
    if (formData.imoNumber === '') {
      formErrors.imoNumber = 'imoNumber cannot be empty';
    }
    if (formData.portOfRegistry === '') {
      formErrors.portOfRegistry = 'portOfRegistry cannot be empty';
    }
    if (formData.officialNumber === '') {
      formErrors.officialNumber = 'officialNumber cannot be empty';
    }
    if (formData.flag === '') {
      formErrors.flag = 'flag cannot be empty';
    }
    if (formData.coastal === '') {
      formErrors.coastal = 'coastal cannot be empty';
    }
    if (formData.dwt === '') {
      formErrors.dwt = 'dwt cannot be empty';
    }
    if (formData.grt === '') {
      formErrors.grt = 'grt cannot be empty';
    }
    if (formData.nrt === '') {
      formErrors.nrt = 'nrt cannot be empty';
    }
    if (formData.arrivalDate === '') {
      formErrors.arrivalDate = 'arrivalDate cannot be empty';
    }
    if (formData.commencementDate === '') {
      formErrors.commencementDate = 'commencementDate cannot be empty';
    }
    if (formData.departureDate === '') {
      formErrors.departureDate = 'departureDate cannot be empty';
    }
    if (formData.transhipment === '') {
      formErrors.transhipment = 'transhipment cannot be empty';
    }
    if (formData.lastPortCall === '') {
      formErrors.lastPortCall = 'lastPortCall cannot be empty';
    }
    if (formData.nextPortCall === '') {
      formErrors.nextPortCall = 'nextPortCall cannot be empty';
    }
    if (formData.completionDate === '') {
      formErrors.completionDate = 'completionDate cannot be empty';
    }
    if (formData.supportingDoc === '') {
      formErrors.supportingDoc = 'supportingDoc cannot be empty';
    }
    if (formData.rate === '') {
      formErrors.rate = 'rate cannot be empty';
    }
    if (formData.quantity === '') {
      formErrors.quantity = 'quantity cannot be empty';
    }
    if (formData.total === '') {
      formErrors.total = 'total cannot be empty';
    }
    if (formData.penaltyDays === '') {
      formErrors.penaltyDays = 'penaltyDays cannot be empty';
    }
    if (formData.penaltyAmount === '') {
      formErrors.penaltyAmount = 'penaltyAmount cannot be empty';
    }
    if (formData.penaltyTotal === '') {
      formErrors.penaltyTotal = 'penaltyTotal cannot be empty';
    }
    if (formData.grandTotal === '') {
      formErrors.grandTotal = 'grandTotal cannot be empty';
    }
    if (formData.tds === '') {
      formErrors.tds = 'tds cannot be empty';
    }
    if (formData.cgst === '') {
      formErrors.cgst = 'cgst cannot be empty';
    }
    if (formData.sgst === '') {
      formErrors.sgst = 'sgst cannot be empty';
    }
    if (formData.igst === '') {
      formErrors.igst = 'igst cannot be empty';
    }
    if (formData.finalAmount === '') {
      formErrors.finalAmount = 'finalAmount cannot be empty';
    }
    if (formData.paymentMode === '') {
      formErrors.paymentMode = 'paymentMode cannot be empty';
    }
    if (formData.paymentStatus === '') {
      formErrors.paymentStatus = 'paymentStatus cannot be empty';
    }


    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/fee_collection_temp/add', formData);
      if (response.data.Status === "SUCCESS") {

      setFormData({

        port: '',
    portType: '',
    feeType: '',
    commodity: '',
    subCommodity: '',
    subSubCommodity: '',
    vessel: '',
    imoNumber: '',
    portOfRegistry: '',

    officialNumber: '',
    flag: '',
    coastal: '',
    dwt: '',
    grt: '',
    nrt: '',
    arrivalDate: '',
    commencementDate: '',
    departureDate: '',
    transhipment: '',

    lastPortCall: '',
    nextPortCall: '',
    completionDate: '',
    supportingDoc: '',
    rate: null,
    quantity: '',
    total: null,
    penaltyDays: null,
    penaltyAmount: null,
    penaltyTotal: null,

    grandTotal: null,
    tds: null,
    cgst: null,
    sgst: null,
    igst: null,
    finalAmount: null,
    paymentMode: '',
    paymentStatus: '',

      });
    }
    else{
      console.log(response.data.message)
    }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add fee_collection_temp</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="port" className="label-custom">port</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.port ? 'input-error' : ''}`}
                        id="port"
                        name="port"
                        value={formData.port}
                        onChange={handleChange}
                      />
                    </div>

             
                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="portType" className="label-custom">portType</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.portType ? 'input-error' : ''}`}
                        id="portType"
                        name="portType"
                        value={formData.portType}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="feeType" className="label-custom">feeType</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.feeType ? 'input-error' : ''}`}
                        id="feeType"
                        name="feeType"
                        value={formData.feeType}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="commodity" className="label-custom">commodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.commodity ? 'input-error' : ''}`}
                        id="commodity"
                        name="commodity"
                        value={formData.commodity}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="subCommodity" className="label-custom">subCommodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.subCommodity ? 'input-error' : ''}`}
                        id="subCommodity"
                        name="subCommodity"
                        value={formData.subCommodity}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="subSubCommodity" className="label-custom">subSubCommodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.subSubCommodity ? 'input-error' : ''}`}
                        id="subSubCommodity"
                        name="subSubCommodity"
                        value={formData.subSubCommodity}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="vessel" className="label-custom">vessel</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.vessel ? 'input-error' : ''}`}
                        id="vessel"
                        name="vessel"
                        value={formData.vessel}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="imoNumber" className="label-custom">imoNumber</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.imoNumber ? 'input-error' : ''}`}
                        id="imoNumber"
                        name="imoNumber"
                        value={formData.imoNumber}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="portOfRegistry" className="label-custom">portOfRegistry</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.portOfRegistry ? 'input-error' : ''}`}
                        id="portOfRegistry"
                        name="portOfRegistry"
                        value={formData.portOfRegistry}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="officialNumber" className="label-custom">officialNumber</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.officialNumber ? 'input-error' : ''}`}
                        id="officialNumber"
                        name="officialNumber"
                        value={formData.officialNumber}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="flag" className="label-custom">flag</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.flag ? 'input-error' : ''}`}
                        id="flag"
                        name="flag"
                        value={formData.flag}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="coastal" className="label-custom">coastal</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.coastal ? 'input-error' : ''}`}
                        id="coastal"
                        name="coastal"
                        value={formData.coastal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="dwt" className="label-custom">dwt</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.dwt ? 'input-error' : ''}`}
                        id="dwt"
                        name="dwt"
                        value={formData.dwt}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="grt" className="label-custom">grt</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.grt ? 'input-error' : ''}`}
                        id="grt"
                        name="grt"
                        value={formData.grt}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="nrt" className="label-custom">nrt</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.nrt ? 'input-error' : ''}`}
                        id="nrt"
                        name="nrt"
                        value={formData.nrt}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="arrivalDate" className="label-custom">arrivalDate</label>
                      <input
                        type="date"
                        className={`input-custom ${errors.arrivalDate ? 'input-error' : ''}`}
                        id="arrivalDate"
                        name="arrivalDate"
                        value={formData.arrivalDate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="commencementDate" className="label-custom">commencementDate</label>
                      <input
                        type="date"
                        className={`input-custom ${errors.commencementDate ? 'input-error' : ''}`}
                        id="commencementDate"
                        name="commencementDate"
                        value={formData.commencementDate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="departureDate" className="label-custom">departureDate</label>
                      <input
                        type="date"
                        className={`input-custom ${errors.departureDate ? 'input-error' : ''}`}
                        id="departureDate"
                        name="departureDate"
                        value={formData.departureDate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="transhipment" className="label-custom">transhipment</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.transhipment ? 'input-error' : ''}`}
                        id="transhipment"
                        name="transhipment"
                        value={formData.transhipment}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="lastPortCall" className="label-custom">lastPortCall</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.lastPortCall ? 'input-error' : ''}`}
                        id="lastPortCall"
                        name="lastPortCall"
                        value={formData.lastPortCall}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="nextPortCall" className="label-custom">nextPortCall</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.nextPortCall ? 'input-error' : ''}`}
                        id="nextPortCall"
                        name="nextPortCall"
                        value={formData.nextPortCall}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="completionDate" className="label-custom">completionDate</label>
                      <input
                        type="date"
                        className={`input-custom ${errors.completionDate ? 'input-error' : ''}`}
                        id="completionDate"
                        name="completionDate"
                        value={formData.completionDate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="supportingDoc" className="label-custom">supportingDoc</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.supportingDoc ? 'input-error' : ''}`}
                        id="supportingDoc"
                        name="supportingDoc"
                        value={formData.supportingDoc}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="rate" className="label-custom">rate</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.rate ? 'input-error' : ''}`}
                        id="rate"
                        name="rate"
                        value={formData.rate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="quantity" className="label-custom">quantity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.quantity ? 'input-error' : ''}`}
                        id="quantity"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="total" className="label-custom">total</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.total ? 'input-error' : ''}`}
                        id="total"
                        name="total"
                        value={formData.total}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="penaltyDays" className="label-custom">penaltyDays</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.penaltyDays ? 'input-error' : ''}`}
                        id="penaltyDays"
                        name="penaltyDays"
                        value={formData.penaltyDays}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="penaltyAmount" className="label-custom">penaltyAmount</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.penaltyAmount ? 'input-error' : ''}`}
                        id="penaltyAmount"
                        name="penaltyAmount"
                        value={formData.penaltyAmount}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="penaltyTotal" className="label-custom">penaltyTotal</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.penaltyTotal ? 'input-error' : ''}`}
                        id="penaltyTotal"
                        name="penaltyTotal"
                        value={formData.penaltyTotal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="grandTotal" className="label-custom">grandTotal</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.grandTotal ? 'input-error' : ''}`}
                        id="grandTotal"
                        name="grandTotal"
                        value={formData.grandTotal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="tds" className="label-custom">tds</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.tds ? 'input-error' : ''}`}
                        id="tds"
                        name="tds"
                        value={formData.tds}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="cgst" className="label-custom">cgst</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.cgst ? 'input-error' : ''}`}
                        id="cgst"
                        name="cgst"
                        value={formData.cgst}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="sgst" className="label-custom">sgst</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.sgst ? 'input-error' : ''}`}
                        id="sgst"
                        name="sgst"
                        value={formData.sgst}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="igst" className="label-custom">igst</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.igst ? 'input-error' : ''}`}
                        id="igst"
                        name="igst"
                        value={formData.igst}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="finalAmount" className="label-custom">finalAmount</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.finalAmount ? 'input-error' : ''}`}
                        id="finalAmount"
                        name="finalAmount"
                        value={formData.finalAmount}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="paymentMode" className="label-custom">paymentMode</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.paymentMode ? 'input-error' : ''}`}
                        id="paymentMode"
                        name="paymentMode"
                        value={formData.paymentMode}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="paymentStatus" className="label-custom">paymentStatus</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.paymentStatus ? 'input-error' : ''}`}
                        id="paymentStatus"
                        name="paymentStatus"
                        value={formData.paymentStatus}
                        onChange={handleChange}
                      />
                    </div>



                  </form>
                </div>

                <div className="modal-footer">

                <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
